var map = {
	"./AG.svg": 486,
	"./AI.svg": 704,
	"./AU.svg": 948,
	"./BE.svg": 709,
	"./BL.svg": 340,
	"./BS.svg": 891,
	"./FR.svg": 70,
	"./FRA.svg": 347,
	"./GE.svg": 954,
	"./GL.svg": 763,
	"./GR.svg": 741,
	"./JU.svg": 157,
	"./LU.svg": 887,
	"./NE.svg": 313,
	"./NW.svg": 339,
	"./OW.svg": 96,
	"./SG.svg": 980,
	"./SH.svg": 755,
	"./SO.svg": 364,
	"./SZ.svg": 129,
	"./TG.svg": 21,
	"./TI.svg": 843,
	"./UR.svg": 7,
	"./VD.svg": 448,
	"./VS.svg": 999,
	"./ZG.svg": 831,
	"./ZH.svg": 944
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 848;